// @flow

import * as React from 'react';

export const getOffsetTop = <T: string>(node: React.ElementRef<T>): number => {
  let current = node;
  let top = 0;
  while (current) {
    // $FlowFixMe[prop-missing]
    top += current.offsetTop;
    // $FlowFixMe[prop-missing]
    current = current.offsetParent;
  }
  return top;
};
